export default "__VITE_ASSET__054381cc__"